<form [formGroup]="form" (ngSubmit)="onSave()" class="flex flex-col gap-4 p-2">
  <!-- SKU Dropdown -->
  <div class="flex flex-col gap-1">
    <label class="font-medium text-sm">
      {{ "lot_barcode.dialog.sku" | translate }} <span class="text-red-500">*</span>
    </label>
    <p-select
      formControlName="skuCode"
      [options]="skuOptions()"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      filterBy="label"
      [loading]="skuLoading()"
      [placeholder]="'lot_barcode.dialog.select_sku' | translate"
      (onFilter)="onSkuFilter($event)"
      class="w-full"
      [style]="{ width: '100%' }"
    ></p-select>
    @if (form.get('skuCode')?.touched && form.get('skuCode')?.hasError('required')) {
      <small class="text-red-500 text-xs">
        {{ "lot_barcode.dialog.sku_required" | translate }}
      </small>
    }
  </div>

  <!-- Lot Value -->
  <div class="flex flex-col gap-1">
    <label class="font-medium text-sm">
      {{ "lot_barcode.dialog.lot_value" | translate }}
    </label>
    <input
      pInputText
      formControlName="lotValue"
      [placeholder]="'lot_barcode.dialog.enter_lot_value' | translate"
      class="w-full"
    />
  </div>

  <!-- Expiry Date -->
  <div class="flex flex-col gap-1">
    <label class="font-medium text-sm">
      {{ "lot_barcode.dialog.expiry_date" | translate }}
    </label>
    <p-datepicker
      formControlName="expiryDate"
      [minDate]="minDate"
      dateFormat="dd/mm/yy"
      [placeholder]="'lot_barcode.dialog.select_expiry_date' | translate"
      [showIcon]="true"
      [style]="{ width: '100%' }"
    ></p-datepicker>
  </div>

  <!-- Buttons -->
  <div class="flex justify-end gap-2 mt-2">
    <p-button
      [label]="'common.actions.cancel' | translate"
      [outlined]="true"
      severity="secondary"
      (onClick)="onCancel()"
    ></p-button>
    <p-button
      [label]="'common.actions.save' | translate"
      type="submit"
      [loading]="saving()"
    ></p-button>
  </div>
</form>

<p-toast></p-toast>
